<div class="wrapper">
    <!-- TODO: should this modal top-div be a component? -->
    <section class="flex justify-between items-center bg-white border-2 border-b-indigo-800">
        <div matDialogTitle>Create new accommodation</div>
        <button type="button" mat-icon-button (click)="close()" title="Close dialog">
            <mat-icon fontIcon="close" aria-label="close icon"></mat-icon>
        </button>
    </section>

    <section body>
        <mat-stepper [orientation]="stepperOrientation" [linear]="true" #stepper>
            <!-- Icon overrides. -->
            <!-- 
            <ng-template matStepperIcon="other_houses" let-index="index">
                <mat-icon>other_houses</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="location" let-index="index">
                <mat-icon>pin_drop</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="image">
                <mat-icon>image</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="call_end">
                <mat-icon>call_end</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="payments">
                <mat-icon>payments</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="domain">
                <mat-icon>domain</mat-icon>
            </ng-template>
             -->
            <mat-step state="other_houses" [stepControl]="specsGroup" (interacted)="specsGroup.markAllAsTouched()" errorMessage="Choose the type">
                <ng-template matStepLabel>Specs</ng-template>
                <ng-container class="flex flex-column justify-content-between">
                    <div #specsStep class="form-step step-1" [formGroup]="specsGroup">
                        <mat-form-field appearance="fill">
                            <mat-label>Accommodation type</mat-label>
                            <mat-select formControlName="accommodation_type">
                                <mat-option *ngFor="let type of accommodationTypes" [value]="type">{{ type }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="showError('specs.accommodation_type', 'required')">Choose the type of place</mat-error>
                            <mat-hint>Choose the one that best describes it.</mat-hint>
                        </mat-form-field>

                        <div formGroupName="available_rooms">
                            <label>What rooms does the accommodation contain?</label>
                            <div class="checkbox-group">
                                <mat-checkbox formControlName="1">Sitting room</mat-checkbox>
                                <mat-checkbox formControlName="2">Kitchen</mat-checkbox>
                                <mat-checkbox formControlName="3">Bedroom</mat-checkbox>
                                <mat-checkbox formControlName="4">Toilet</mat-checkbox>
                                <mat-checkbox formControlName="5">Bathroom</mat-checkbox>
                                <mat-checkbox formControlName="6">Dining room</mat-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-between items-center pt-6">
                        <button type="button" mat-stroked-button color="primary" (click)="next(specsGroup, specsStep)">
                            Next
                        </button>
                    </div>
                </ng-container>
            </mat-step>

            <mat-step state="pin_drop" [stepControl]="locationGroup" (interacted)="locationGroup.markAllAsTouched()">
                <ng-template matStepLabel>Location</ng-template>

                <div class="flex flex-column justify-content-between">
                    <div #locationStep class="form-step step-2" [formGroup]="locationGroup">
                        <mat-form-field appearance="fill">
                            <mat-label>Address</mat-label>
                            <input matInput formControlName="address" placeholder="Please specify street, and area." />
                        </mat-form-field>

                        <mat-form-field class="example-full-width">
                            <mat-label>Directions</mat-label>
                            <textarea rows="3" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" cdkTextareaAutosize
                                matInput formControlName="directions"
                                placeholder="Give directions to the accommodation from a popular nearby junction, a land mark or hard-to-miss building"></textarea>
                            <mat-hint>
                                Use a landmark, or hard to miss things in directions.
                            </mat-hint>
                        </mat-form-field>
                    </div>

                    <div class="flex justify-between items-center pt-6">
                        <div class="flex gap-2">
                            <button type="button" mat-stroked-button matStepperPrevious>
                                Back
                            </button>
                            <button type="button" mat-stroked-button color="primary" (click)="next(locationGroup, locationStep)">
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>

            <mat-step label="Let's see it" state="image" [optional]="true">
                <div class="form-step step-1">
                    <input title="Select files" #imgFileInput class="custom-file-input" accept="image/*,video/*"
                        multiple (change)="onFileSelected($event)" type="file" />

                    <div *ngIf="accommodationImagesPreview.length" class="images-preview">
                        <ng-container *ngFor="
                                let image of accommodationImagesPreview;
                                let imgIndex = index
                            ">
                            <mat-card>
                                <img [src]="image.dataUrl" mat-card-image alt="A supposed image of the apartment" />
                                <mat-divider></mat-divider>
                                <mat-card-actions class="custom-img-actions">
                                    <mat-form-field class="what-img" appearance="fill">
                                        <mat-label>Identify image</mat-label>
                                        <mat-select>
                                            <mat-option>Choose</mat-option>
                                            <mat-option *ngFor="
                                                    let food of availableHouseRooms
                                                " [value]="food.value">
                                                {{ food.viewValue }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- <button type="button" class="hide-mobile" (click)="removePreviewImage(imgIndex)" mat-stroked-button color="warn" aria-label="Delete image">
                                        Delete
                                    </button> -->
                                    <button type="button" (click)="removePreviewImage(imgIndex)" mat-icon-button
                                        aria-label="Delete image" color="warn">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </mat-card-actions>
                            </mat-card>
                        </ng-container>
                    </div>
                </div>

                <div class="flex justify-between items-center pt-6">
                    <div class="flex gap-2">
                        <button type="button" mat-stroked-button matStepperPrevious>
                            Back
                        </button>
                        <button type="button" mat-stroked-button color="primary" matStepperNext>
                            Next
                        </button>
                    </div>
                </div>
            </mat-step>

            <mat-step state="domain" [stepControl]="statusGroup" (interacted)="statusGroup.markAllAsTouched()" errorMessage="Choose the status">
                <ng-template matStepLabel>Current status</ng-template>

                <div #statusStep class="form-step step-3" [formGroup]="statusGroup">
                    <div>
                        <label id="accommodation-current-status">
                            What's the current status of the accommodation?
                        </label>
                        <div>
                            <mat-radio-group class="flex flex-col gap-4" formControlName="status"
                                aria-labelledby="accommodation-current-status"
                                [attr.aria-describedby]="showError('status.status') ? 'accommodation-status-error' : null">
                                <mat-radio-button value="new_rent">
                                    <h3 class="text-base">New rent (No occupant)</h3>
                                    <p>(Un)furnished and immediately available</p>
                                </mat-radio-button>
                                <mat-radio-button value="seeking_roommate">
                                    <h3 class="text-base">Seeking a roommate</h3>
                                    <p>You want to split the rent with someone else</p>
                                </mat-radio-button>

                                <mat-radio-button value="active_rent" class="flex">
                                    <div>
                                        <h3 class="text-base">Subleasing an active
                                            rent</h3>
                                        <p>You want someone to take the apartment before/when your rent expires</p>
                                    </div>
                                </mat-radio-button>

                                <!-- @todo: need to discuss how this will work -->
                                <!-- <mat-radio-button value="free" class="flex">
                                    <div>
                                        <h3 class="text-base">Free accommodation</h3>
                                        <p>The apartment is free for corp members</p>
                                    </div>
                                </mat-radio-button> -->
                            </mat-radio-group>
                        </div>
                        <p *ngIf="showError('status.status', 'required')" id="accommodation-status-error"
                            matError class="m-0 mt-2 text-xs" role="alert">Choose what's happening with the place</p>
                    </div>

                    <div *ngIf="statusGroup.controls.status.value === 'active_rent'">
                        <mat-form-field appearance="fill" class="rent-expire-form-field">
                            <mat-label>When does your rent expire</mat-label>
                            <!-- Picked, not typed: readonly, and the calendar opens on focus or a tap, so nobody has to
                                 guess the format. The calendar can't pick a past date ([min]). -->
                            <input title="Date your rent expires" matInput [matDatepicker]="picker" readonly
                                formControlName="rent_expire_date" [min]="today"
                                (focus)="openDatepicker(picker)" (click)="picker.open()" />
                            <mat-hint>An estimate is fine</mat-hint>
                            <mat-error *ngIf="showError('status.rent_expire_date', 'required')">
                                Pick when your rent runs out - an estimate is fine
                            </mat-error>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker (closed)="datepickerJustClosed = true"></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <ng-container *ngIf="statusGroup.controls.status.value === 'seeking_roommate'">
                        <mat-form-field class="example-full-width">
                            <mat-label>Describe your ideal roommate:</mat-label>
                            <textarea rows="3" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" matInput
                                placeholder="Someone nice..." formControlName="ideal_roommate"></textarea>
                            <mat-hint>Optional</mat-hint>
                        </mat-form-field>

                        <mat-form-field class="example-full-width">
                            <mat-label>Describe <b>Yourself</b> to your ideal
                                roommate:</mat-label>
                            <textarea rows="3" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" matInput
                                placeholder="I'm tolerant, clean..." formControlName="occupant_description"></textarea>
                            <mat-hint>Optional</mat-hint>
                        </mat-form-field>
                    </ng-container>
                </div>

                <div class="flex justify-between items-center pt-6">
                    <div class="flex gap-2">
                        <button type="button" mat-stroked-button matStepperPrevious>
                            Back
                        </button>
                        <button type="button" mat-stroked-button color="primary" (click)="next(statusGroup, statusStep)">
                            Next
                        </button>
                    </div>
                </div>
            </mat-step>

            <mat-step state="call_end" [stepControl]="contactGroup" (interacted)="contactGroup.markAllAsTouched()" errorMessage="Check the numbers">
                <ng-template matStepLabel>Contact</ng-template>

                <div class="flex flex-column justify-content-between">
                    <div #contactStep class="form-step step-phone" [formGroup]="contactGroup">
                        <p>Add phone numbers for interested corp members to contact you (optional)</p>

                        <div formArrayName="phone_numbers">
                            <div *ngFor="let phoneControl of phoneNumbersFormArray.controls; let i = index"
                                class="flex items-center gap-2 mb-2">
                                <mat-form-field appearance="fill" class="flex-1">
                                    <mat-label>Phone number {{ i + 1 }}</mat-label>
                                    <input matInput [formControl]="getPhoneNumberControl(i)"
                                        placeholder="e.g., +234 801 234 5678" type="tel" autocomplete="tel" />
                                    <mat-error *ngIf="showError('contact.phone_numbers.' + i, 'phoneNumber')">
                                        Enter a phone number like 0801 234 5678
                                    </mat-error>
                                </mat-form-field>
                                <button type="button" mat-icon-button color="warn" (click)="removePhoneNumber(i)"
                                    aria-label="Remove phone number" *ngIf="phoneNumbersFormArray.length > 0">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>

                        <button type="button" mat-stroked-button color="primary" (click)="addPhoneNumber()">
                            <mat-icon>add</mat-icon>
                            Add phone number
                        </button>
                    </div>

                    <div class="flex justify-between items-center pt-6">
                        <div class="flex gap-2">
                            <button type="button" mat-stroked-button matStepperPrevious>
                                Back
                            </button>
                            <button type="button" mat-stroked-button color="primary" (click)="next(contactGroup, contactStep)">
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>

            <!-- Complete only once it's posted, not once it's valid: a linear stepper only checks the steps before the one
                 picked, so a valid last step would let the Done header be clicked without posting. -->
            <mat-step state="payments" [completed]="posted" [hasError]="costGroup.invalid && costGroup.touched"
                (interacted)="costGroup.markAllAsTouched()" errorMessage="Add the rent">
                <ng-template matStepLabel>How much it costs</ng-template>
                <div #costStep class="form-step step-4" [formGroup]="costGroup">
                    <div>
                        <label id="accommodation-periodic-rent">Rent is</label>
                        <mat-radio-group class="radio-group" formControlName="rent_interval"
                            aria-labelledby="accommodation-periodic-rent"
                            [attr.aria-describedby]="showError('cost.rent_interval') ? 'accommodation-interval-error' : null">
                            <mat-radio-button value="yearly">Yearly</mat-radio-button>
                            <mat-radio-button value="quarterly">Quarterly</mat-radio-button>
                            <mat-radio-button value="monthly">Monthly</mat-radio-button>
                            <mat-radio-button value="custom">Custom</mat-radio-button>
                            <mat-radio-button value="free">Free</mat-radio-button>
                            <!-- TODO: If they choose custom rent, then should they specify how it's custom (with like a textbox)? -->
                        </mat-radio-group>
                        <p *ngIf="showError('cost.rent_interval', 'required')" id="accommodation-interval-error"
                            matError class="m-0 mt-2 text-xs" role="alert">Choose how often rent is paid, or Free</p>
                    </div>

                    <mat-form-field *ngIf="costGroup.controls.rent_interval.value !== 'free'" class="example-full-width">
                        <mat-label>{{ rentInputLabel }}</mat-label>
                        <span matPrefix>&nbsp;&nbsp; &#8358; &nbsp;</span>
                        <!-- text, not number, so "50,000" can be typed (the backend drops the commas) -->
                        <input formControlName="rent" type="text" inputmode="numeric" matInput placeholder="50,000" />
                        <mat-error *ngIf="showError('cost.rent', 'required')">Enter the rent, or choose Free</mat-error>
                        <mat-error *ngIf="showError('cost.rent', 'notANumber')">Use numbers only, like 50,000</mat-error>
                        <mat-error *ngIf="showError('cost.rent', 'min')">The rent has to be at least &#8358;1</mat-error>
                    </mat-form-field>
                </div>

                <div class="flex justify-between items-center pt-6">
                    <div class="flex items-center gap-2">
                        <button type="button" mat-stroked-button matStepperPrevious>
                            Back
                        </button>


                        <app-progress-button (click)="submit(costStep)" [loading]="postingAccommodation"
                            buttonText="Post"></app-progress-button>

                    </div>

                    <!-- less @todo: make the button flat? -->
                    <app-progress-button (click)="submit(costStep, true)" [loading]="draftingAccommodation" [buttonColor]="null"
                        buttonText="Save as draft"></app-progress-button>
                </div>
            </mat-step>

            <!-- Success Step (following Wise Summary pattern: https://wise.design/components/summary) -->
            <mat-step state="done" [editable]="false">
                <ng-template matStepLabel>Done</ng-template>
                
                <div class="form-step success-step py-4">
                    <!-- Success Header -->
                    <div class="flex items-center gap-3 mb-6">
                        <div class="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                            <mat-icon class="!w-6 !h-6 !text-[24px] text-emerald-600">check</mat-icon>
                        </div>
                        <h2 class="text-xl font-semibold text-primary m-0">Apartment posted</h2>
                    </div>

                    <!-- Summary List -->
                    <div class="border border-gray-200 rounded-xl divide-y divide-gray-200 bg-white">
                        <!-- Item 1: Assist corper -->
                        <div class="flex items-start gap-3 p-4">
                            <mat-icon class="!w-5 !h-5 !text-[20px] text-primary flex-shrink-0 mt-0.5">handshake</mat-icon>
                            <div>
                                <p class="font-medium text-primary m-0">Assist the new corper</p>
                                <p class="text-sm text-text-secondary m-0 mt-1">Help them take over the apartment with ease.</p>
                            </div>
                        </div>

                        <!-- Item 2: Never collect landlord payments -->
                        <div class="flex items-start gap-3 p-4">
                            <mat-icon class="!w-5 !h-5 !text-[20px] text-red-500 flex-shrink-0 mt-0.5">money_off</mat-icon>
                            <div>
                                <p class="font-medium text-primary m-0">Never collect landlord payments</p>
                                <p class="text-sm text-text-secondary m-0 mt-1">The renter only pays you an assistance fee.</p>
                            </div>
                        </div>

                        <!-- Item 3: Assistance fee -->
                        <div class="flex items-start gap-3 p-4">
                            <mat-icon class="!w-5 !h-5 !text-[20px] text-brand-orange flex-shrink-0 mt-0.5">payments</mat-icon>
                            <div>
                                <p class="font-medium text-primary m-0">Assistance fee is ₦10,000</p>
                                <p class="text-sm text-text-secondary m-0 mt-1">Request only after inspection, agreement, and confirmation. Do not ask if they're not taking it.</p>
                            </div>
                        </div>

                        <!-- Item 4: Reply messages -->
                        <div class="flex items-start gap-3 p-4">
                            <mat-icon class="!w-5 !h-5 !text-[20px] text-primary flex-shrink-0 mt-0.5">chat</mat-icon>
                            <div>
                                <p class="font-medium text-primary m-0">Reply messages promptly</p>
                                <p class="text-sm text-text-secondary m-0 mt-1">Don't keep interested renters waiting.</p>
                            </div>
                        </div>

                        <!-- Item 5: Safety -->
                        <div class="flex items-start gap-3 p-4">
                            <mat-icon class="!w-5 !h-5 !text-[20px] text-primary flex-shrink-0 mt-0.5">shield</mat-icon>
                            <div>
                                <p class="font-medium text-primary m-0">Transact safely</p>
                                <p class="text-sm text-text-secondary m-0 mt-1">
                                    Read our <a href="/about#disclaimer" class="text-brand-orange hover:underline">User Guide</a> to avoid fraudsters.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pt-5">
                    <button type="button" mat-raised-button color="primary" (click)="close()">
                        Done
                    </button>
                </div>
            </mat-step>
        </mat-stepper>
    </section>
</div>

<!--
    Helper links:
    1. https://stackoverflow.com/questions/53132581/override-the-default-icon-from-mat-stepper-angular-material
    2. https://github.com/angular/components/issues/8997
    3. https://stackblitz.com/angular/maxbjapeayr?file=app%2Fstepper-states-example.ts
-->
